import { FC, PropsWithChildren } from 'react'
import { isIterable } from '@omnea-app/fe-legacy/utils/type-guard/isIterable'

interface Props extends Record<string, unknown>, PropsWithChildren {}

export const ChildrenProxy: FC<Props> = ({ children }) => (isIterable(children) ? <>{children}</> : children)
